/**
 * Global animation play state (shared with Information.js via pauseAnimation)
 */
export const animationState = { play: false };

export const setPlay = (value) => {
    animationState.play = value;
};

export const togglePlayState = () => {
    animationState.play = !animationState.play;
};

export const pauseAnimation = () => {
    animationState.play = false;
};
